import type { AnyFunction } from './types';

export const isFunction = (val: unknown): val is AnyFunction => typeof val === 'function';
